import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { listDirty } from "./dirtyRegistry";

/**
 * UnsavedChangesDialog - conferma prima del cambio contesto.
 *
 * Coerente con lo stile dei dialog gia' usati nella Suite. Presenta 3
 * scelte:
 *   - Annulla        (chiude il dialog, resta sul contesto attuale)
 *   - Salva          (opzionale, chiama onSave se fornito)
 *   - Scarta e continua (`discardAllDirty()` + apply switch)
 */
export function UnsavedChangesDialog({ open, onClose, onDiscard, onSave, itemsPreview = true }) {
  const [saving, setSaving] = useState(false);
  const items = listDirty();
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent data-testid="suite-unsaved-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle>Sono presenti modifiche non salvate</DialogTitle>
          <DialogDescription>
            Vuoi salvarle prima del cambio contesto? Se procedi senza salvare,
            le modifiche verranno perse.
          </DialogDescription>
        </DialogHeader>
        {itemsPreview && items.length > 0 && (
          <ul className="my-2 max-h-32 overflow-y-auto rounded-md bg-suite-neutral-50 p-2 text-xs text-suite-neutral-600">
            {items.map((it) => (
              <li key={it.id}>· {it.label || it.id}</li>
            ))}
          </ul>
        )}
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} data-testid="unsaved-cancel">
            Annulla
          </Button>
          {onSave && (
            <Button
              onClick={async () => {
                setSaving(true);
                try { await onSave(); } finally { setSaving(false); }
              }}
              disabled={saving}
              data-testid="unsaved-save"
            >
              {saving ? "Salvataggio..." : "Salva e continua"}
            </Button>
          )}
          <Button
            variant="destructive"
            onClick={onDiscard}
            data-testid="unsaved-discard"
          >
            Scarta e continua
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
